<template>
  <div class="app__main_vue">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  overflow-x: auto;
  /* color: #ddd; */
}
html {
  margin: 0 auto;
  background-color: #202020;
  box-sizing: border-box;
}
body, h1, h2, h3, h4, h5, h6, ol, p, ul {
  margin: 0;
  padding: 0;
}
</style>
